// extracted by mini-css-extract-plugin
export default {"mobile_apps_block":"mobile-apps_mobile_apps_block__aTEk+","main_block":"mobile-apps_main_block__f-Dgs"};